import { themedUseStyletron } from '../theme/customTheme';

export function useStyles() {
  const [css, theme] = themedUseStyletron();

  const fillParent = css({
    width: '100%',
    height: '100%',
  });

  const horizontalFlex = css({
    display: 'flex',
  });

  const verticalFlex = css({
    display: 'flex',
    flexDirection: 'column',
  });

  const centeredFlex = css({
    alignItems: 'center',
    justifyContent: 'center',
  });

  const centeredStart = css({
    alignItems: 'center',
    justifyContent: 'start',
  });

  const centeredEnd = css({
    alignItems: 'center',
    justifyContent: 'end',
  });

  const flexFill = css({
    flex: '1 1 100%',
  });

  const ellipseText = ({ maxLines = 3, breakAll = false }) =>
    css({
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': maxLines,
      display: '-webkit-box',
      overflow: 'hidden',
      wordBreak: breakAll ? 'break-all' : 'break-word',
    });

  const warn = css({
    color: theme.colors.negative,
  });

  const success = css({
    color: theme.colors.positive,
  });

  const colors = {
    warn,
    success,
  };

  const dataHeaderClass = css({
    paddingTop: theme.sizing.scale200,
    paddingBottom: theme.sizing.scale200,
    paddingLeft: theme.sizing.scale500,
    paddingRight: theme.sizing.scale500,
    backgroundColor: theme.colors.backgroundTertiary,
  });

  const dataContentClass = css({
    paddingLeft: theme.sizing.scale500,
    paddingRight: theme.sizing.scale500,
  });

  const flexible = (flex: number) =>
    css({
      flex,
    });

  const classes = {
    fillParent,
    horizontalFlex,
    verticalFlex,
    centeredFlex,
    centeredStart,
    centeredEnd,
    flexFill,
    ellipseText,
    dataHeaderClass,
    dataContentClass,
    flexible,
  };

  const concatenateClasses = (...classes: string[]) => {
    return classes.join(' ');
  };

  return { css, theme, classes, colors, concatenateClasses };
}
